
























































































































































import Vue from 'vue';
import _ from 'lodash';
import store from "@/store";
import { API } from "aws-amplify";
import { Constants } from "@/api-constants";
import { mapState, mapGetters } from 'vuex';
import TeamCardMenu from '@/components/team/teams-card-menu.vue';
import TeamInviteButton from '@/components/team/team-invite-button.vue';
import TeamViewpointButton from '@/components/team/team-viewpoint-button.vue';

export default Vue.extend({

  name: 'TeamCard',

  components: {
    'team-card-menu': TeamCardMenu,
    'team-invite-button': TeamInviteButton,
    'team-viewpoint-button': TeamViewpointButton,
  },

  props: {
    team: {
      type: Object,
      default:  () => {},
    },
    viewpoints: {
      type: Array,
      default:  () => [],
    },
  },

  data() {
    return {
      deleteDialog: false,
      editDialog: false,
      valid: false,
      vp_updating: false,
      message: 'Your team is being created ...',
      showMessage: false,
      formSubject: '' as any,
      ruleSubject: [
        (v: any) => !!v || '"Team Name" is required',
        (v: any) =>
          (v && v.length <= 100) ||
          '"Team Name" must be less than 100 characters'
      ],
      formBody: '' as any,
      ruleBody: [
        // (v: any) => !!v || '"Description" is required',
        (v: any) =>
          ( !v || (v.length <= 500)) ||
          '"Description" must be less than 500 characters'
      ],
    };
  },

  created() {
  },

  mounted() {
  },

  watch: {
  },

  computed: {
    // mix the getters into computed
    ...mapGetters([
      'getFavourites',
      'getIsLoggedIn',
      'getInstanceId',
      'getVpInstances',
      'getVpInstancesCount',
      'getVpInstanceList',
      'getVpInstanceListCount',
      'getVpGroups',
      'getVpGroupsCount',
      'getVpGroupsList',
      'getVpGroupsListCount',
      'getVpGroupInstances',
      'getVpGroupInstancesCount',
      'getVpGroupInstancesList',
      'getVpGroupInstancesListCount'
    ]),
    teamName(): string {
      if (Object.keys(this.team).length){
        let name: string  = ( this.team.name ? String(this.team.name) : '' );
        let res: string = ( name.length > 8 ? String(name.substring(0, 8)) + '...' : String(name) );
        return res;
      } else {
      return '';
      }
    },
    numberOfTeamMembers(): number {
      return this.team.users.length + this.team.adminUsers.length;
    },
    numberOfSharedViewpoints(): number {
      return this.team.viewpoints.length;
    },
    isValidEdit(): boolean {
      return (this.valid && !!this.formSubject);
    },
  },

  methods: {

    deleteTeamDialog(team: object) {
      this.deleteDialog = true;
      console.log('vp-team-card > deleteTeamDialog():');
      console.log(team);
    },

    deleteTeam(team: object) {
      console.log('vp-team-card > teamDeleteConfirm():');
      console.log(team);
      store.dispatch("deleteTeam", team);
      this.deleteDialog = false;
    },

    editTeamDialog(team: any) {
      this.editDialog = true;
      if (team.name) { this.formSubject = team.name; }
      if (team.description) { this.formBody = team.description; }
      console.log('vp-team-card > editTeamDialog():');
      console.log(team);
    },

    editTeam(team: any) {
      if (this.formSubject ) {
        let payload: any = {...team};
        payload.name = this.formSubject;
        // TODO - FIX: Team Description not allowing an empty edit
        if (this.formBody.length) {
          payload.description = this.formBody;
        } else {
          payload.description = '';
        }
        console.log('vp-team-card > teamEditConfirm():');
        console.log(payload);
        store.dispatch("editTeam", payload);
      }
      this.editDialog = false;
    },

  },


});

